import { CheckCheck } from "lucide-react";
import type {
  ActionNodeReturnAutoTreatConfigDto,
  WorkflowV2NodeDto,
} from "@babackapp/private-api-client/types";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { ReturnAutoTreatActionNodeEditor } from "./editor";
import { ReturnAutoTreatActionNodePanel } from "./panel";

const newNodeDefaultValue = {
  actionType: "auto_treat_return",
  config: {
    mode: "mark_treated",
  } satisfies ActionNodeReturnAutoTreatConfigDto,
};

export default registerNode<ActionNodeReturnAutoTreatConfigDto>({
  type: "action:auto_treat_return",
  name: "workflowsEditor.nodes.autoTreatReturn.title",
  description: "workflowsEditor.nodes.autoTreatReturn.description",
  Icon: CheckCheck,
  category: NodeCategory.ACTION,
  color: "orange",
  editor: {
    component: ReturnAutoTreatActionNodeEditor,
  },
  configPanel: {
    component: ReturnAutoTreatActionNodePanel,
  },
  // Extended action type outside the generated V2 union (return engine).
  newNodeDefaultData: newNodeDefaultValue as unknown as WorkflowV2NodeDto["data"],
});

export { ReturnAutoTreatActionNodeEditor } from "./editor";
export { ReturnAutoTreatActionNodePanel } from "./panel";
